<div class="bg-white p-3 shadow-3 border-round-sm">
    <div class="rem-text-default flex align-items-center">
          <div class="rem-bg-light p-2 mr-2">
            <i class="pi pi-wallet font-medium"></i>
          </div>
          <div class="text-lg">Payments</div>
        </div>

        <div class="mt-5">
          <div class="px-3 flex align-items-center gap-3">
            <p-floatLabel>
            <p-multiSelect
              [style]="{width: '200px'}"
              id="creditorsPayments"
              [options]="creditors"
              [(ngModel)]="selectedCreditors"
              (ngModelChange)="onChangeCreditors($event)"
              optionLabel="label"
              filterBy="value,label">
              <ng-template let-creditor pTemplate="item">
                <div class="flex align-items-center justify-content-between flex-1">
                  <div>{{ creditor.label }}</div>
                  <div class="ml-2">{{ creditor.value }}</div>
                </div>
              </ng-template>
            </p-multiSelect>
            <label for="creditorsPayments">Select Clients</label>
            </p-floatLabel>
            
            <p-floatLabel>
              <p-calendar 
                    id="fromDatePayments"
                    [(ngModel)]="fromDate"
                    [readonlyInput]="true"      
                    [maxDate]="toDate"             
              >
              </p-calendar>
              <label for="fromDatePayments">From Date</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-calendar 
                    id="toDatePayments"
                    [(ngModel)]="toDate"
                    [readonlyInput]="true"            
                    [minDate]="fromDate"
                    [maxDate]="todaysDate"
              >
              </p-calendar>
              <label for="toDatePayments">To Date</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-multiSelect
                  [style]="{width: '200px'}"
                  id="typesPayments"
                  [options]="paymentTypes"
                  [(ngModel)]="selectedPaymentTypes"
                  (ngModelChange)="onChangePaymentTypes($event)"
                  optionLabel="label"
                  optionValue="value"                   
                  />
                <label for="typesPayments">Payment Type</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-multiSelect
                  [style]="{width: '200px'}"
                  id="statusesPayments"
                  [options]="paymentStatuses"
                  [(ngModel)]="selectedPaymentStatuses"
                  (ngModelChange)="onChangePaymentStatuses($event)"
                  optionLabel="label"
                  optionValue="value"                   
                />
                <label for="statusesPayments">Status</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-dropdown 
                      [showClear]="true"
                      id="timezonesPayments" 
                      [options]="timezones"
                      [(ngModel)]="selectedTimezone"
                      optionLabel="label" 
                      optionValue="value" 
                />
                <label for="timezonesPayments">Timezone</label>
            </p-floatLabel>
    
            <remitter-button
              label='Generate'
              icon='send'
              (click)="getGraph()"
            >     
            </remitter-button>
          </div>

          <div class="px-3 mt-5 flex justify-content-end px-3">
            <p-selectButton 
                [options]="graphTotalType" 
                [(ngModel)]="selectedGraphTotalType" 
                (onChange)="getGraph()"
                optionValue="value"
                >
                <ng-template  let-item pTemplate>
                    <div class="flex align-items-center gap-2" tooltipPosition="top" [pTooltip]="item.tooltip">
                      <i class="text-xs" [class]="item.icon"></i>
                      <div class="text-sm">{{item.label}}</div>
                    </div>
                  </ng-template>
            </p-selectButton>    
          </div>

          <div class="chart-payments-div pt-5">
            <div class="font-bold text-700 text-lg">Recovery Performance by Creditor</div>
            <div *ngIf="isArrayWithData(chartOptions)">
              <div
                  *ngFor="let chart of chartOptions; let i = index"
                  echarts
                  [options]="chart"
                  class="echart"
                  [ngStyle]="{ minHeight: chart['dataLength'] === 10? 'auto' : getGraphHeight(chart['dataLength']) }"
              ></div>
            </div>
             <div *ngIf="!isArrayWithData(chartOptions)" class="flex align-items-center justify-content-center h-20rem">
               <div class="font-bold text-red-700">There is no data to display. Please adjust your filter.</div>
             </div>
          </div>
        </div>

        <div class="mt-4 flex align-items-center gap-3 px-3">
          <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-chart-bar text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Total Gathered</div>
                <div *ngIf="selectedGraphTotalType === 1" class="text-lg rem-text-default font-bold">{{ (totalGatheredPayments || 0 ) | currency:'USD':'symbol':'1.2-2' }}</div>
                <div *ngIf="selectedGraphTotalType === 2" class="text-lg rem-text-default font-bold">{{ (totalGatheredPayments || 0 ) | number }}</div>       
              </div>
          </div>

          <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i *ngIf="selectedGraphTotalType === 1" class="pi pi-dollar text-2xl rem-text-default"></i>
                <i *ngIf="selectedGraphTotalType === 2" class="pi pi-calculator text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Total Paid</div>
                <div *ngIf="selectedGraphTotalType === 1" class="text-lg rem-text-default font-bold">{{ (totalPaidPayments || 0 ) | currency:'USD':'symbol':'1.2-2' }}</div>
                <div *ngIf="selectedGraphTotalType === 2" class="text-lg rem-text-default font-bold">{{ (totalPaidPayments || 0 ) | number }}</div>                
              </div>
          </div>


          <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-ban text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Total Declined</div>
                <div *ngIf="selectedGraphTotalType === 1" class="text-lg rem-text-default font-bold">{{ (totalDeclinedPayments || 0 ) | currency:'USD':'symbol':'1.2-2' }}</div>
                <div *ngIf="selectedGraphTotalType === 2" class="text-lg rem-text-default font-bold">{{ (totalDeclinedPayments || 0 ) | number }}</div>
              </div>
          </div>

          <!-- <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-hourglass text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Total Awaiting Payment</div>
                <div class="text-lg rem-text-default font-bold">{{ (totalAwaitingPayments || 0 ) | currency:'USD':'symbol':'1.2-2' }}</div>
              </div>
          </div> -->


        </div>
</div>
